import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsSchemaConfigurationRoute: InvariantJiraRoute = {
	name: 'assets-schema-configuration',
	path: '/jira/assets/configure/object-schema/:objectSchemaId',
};
